export const APP_SHELL_MOBILE_BREAKPOINT = '640px';
export const APP_SHELL_MOBILE_QUERY = `(max-width: ${APP_SHELL_MOBILE_BREAKPOINT})`;
